// adminClient.js -- GET /m08/api/admin?key=<API_KEY> returns tenant + billing config